module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "pageiv"
    }
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_vm._v("Contents")])]), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "pageiv"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/04_List_of_Maps"
    }
  }, [_vm._v("List of Maps")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Preface"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Note_on_Sources"
    }
  }, [_vm._v("A Note on Sources")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Environment"
    }
  }, [_vm._v("The Environment: Nomads and Sedentary States")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Khitan_War_Machine"
    }
  }, [_vm._v("The Khitan War Machine")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Part1"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Part I: Genghis Khan")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter_01"
    }
  }, [_vm._v("1     Temüjin")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/12_Chapter_02"
    }
  }, [_vm._v("2     The Officers")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter_03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3     The Mongol Army")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter_03a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Overview: Ally of To’oril, 1191 to 1202")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4     The First Raid on the Merkits (Map 1)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter_05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5     The Victory of Jamuqa (Map 1)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter_06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6     The Defeat of the Tatars (Map 2)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter_07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7     Showdown with the Jürkins and the Restoration of To’oril (Map 3)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter_08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.     Further Raids on the Merkits (Map 3)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter_09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9     War with the Naimans (Maps 4, 5)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10   Migrating to the Eastern Regions (Map 6)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11   Overcoming the Tribes in the East (Map 7)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12   Confrontation at Köyiten (Map 8)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter_12a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Overview: Master of Mongolia, 1203 to 1208")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13   To’oril’s Bid for Supremacy (Map 9)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14   The Showdown with the Naimans (Maps 10, 11, 18)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15   The Defeat of Buyiruq (Maps 4, 23)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Chapter_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16   The Conquest of Wulahai (Maps 11, 23)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Chapter_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17   Battle Along the Buqdurma (Map 4)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter_17a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Overview: The Chinese Campaigns I, 1209 to 1215")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Chapter_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18   Assault on Xia (Maps 11, 18)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/32_Chapter_19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19   The Road to Beijing (Map 12)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/33_Chapter_20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20   The Failed Siege of Datong (Map 13)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/34_Chapter_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21   Into Central China (Map 13)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Chapter_22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22   The Siege of Beijing (Map 13)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/36_Chapter_23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23   The Continued War Against Jin (Maps 11, 13, 21, 23)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/37_Chapter_24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24   Incidents at Home (Map 1)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/38_Chapter_24a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Overview: The Great Western Expedition, 1219 to 1224")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/39_Chapter_25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25   The defeat of Muhammad II (Map 14)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/40_Chapter_26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26   Khwarezm Crushed (Map 15)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/41_Chapter_27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27   Mopping-Up Operations (Map 15)")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/42_PartII",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Part II: Sübe’etei")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/43_Chapter_28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28   Sübe’etei")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/44_Chapter_29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29   The Early Life of Sübe’etei")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/45_Chapter_29a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Overview: Circling the Caspian Sea, 1216 to 1224")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/46_Chapter_30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30   Defeat of Qudu’s Merkits (Map 14)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/47_Chapter_31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31   The Hunt for Küclüg (Map 14)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/48_Chapter_32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32   Rendezvous on the Irghiz River (Map 14)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/49_Chapter_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33   The Hunt for Muhammad II and Raid into Georgia (Map 16)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/50_Chapter_34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34   Across the Caucasus Mountains (Map 17)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/51_Chapter_35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35   And Quiet Flows the Don (Map 17)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/52_Chapter_36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36   Conflict Along the Volga (Map 17)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/53_Chapter_36a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Overview: The Chinese Campaigns II, 1226 to 1234")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/54_Chapter_37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37   The Destruction of the Xia State (Map 18)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/55_Chapter_38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38   Testing the Border Defences of Jin and Song (Map 18)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/56_Chapter_39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39   The Caspian Sea (Map 24)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/57_Chapter_40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40   Defeat in Daohui Valley (Map 19)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/58_Chapter_41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41   The Battle of Sanfeng (Maps 20, 21)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/59_Chapter_42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42   The Siege of Kaifeng (Map 22)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/60_Chapter_43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43   The End of Jin (Map 22)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/61_Chapter_44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44   Recovering Luoyang in the Year of Duanping (Map 23)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/62_Chapter_45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45   The Mongol Invasions of Korea")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/63_Chapter_45a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Overview: The European Campaigns, 1236 to 1246")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/64_Chapter_46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46   Destruction of the Bulgar State (Map 23)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/65_Chapter_47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47   The Conquest of Russia (Map 23)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/66_Chapter_48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48   Securing the Plains Around the Black Sea (Maps 17, 23)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/67_Chapter_49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49   The Conquest of Chernigov (Map 23)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/68_Chapter_50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50   The Invasion of Hungary and Poland (Map 24)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/69_Chapter_51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51   Into the Heart of Europe? (Map 24)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/70_Chapter_52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52   The Mongol–Song War (Map 23)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/71_Chapter_53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53   Again Against the Song (Map 23)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/72_Chapter_54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54   Conclusions")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/73_AppendixI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendices")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/73_AppendixI#app1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I      The Breakdown of the Mongol army")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/74_AppendixII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II     Battles of the Mongols and their Allies")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/75_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9ee5fb14","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 63
// module chunks = 0